module.exports = __webpack_public_path__ + "static/slide8-a8aaa3de865d08679c79c2c7b8c4b81e.jpg";